import { useQuery } from '@tanstack/react-query'
import { WorkingHoursEditor } from './WorkingHoursEditor'
import { InformationalWorkingHoursSettings } from './InformationalWorkingHoursSettings'
import type { SettingsRepository } from './settings-repository'
import type { ProviderResourceRepository } from './provider-resource-repository'

export function WorkingHoursSettings(props: {
  tenantId: string
  tenantLabel: string
  repository: SettingsRepository
  providerResourceRepository?: ProviderResourceRepository
  /** Owners and Admins only: see `canViewClinicTechnicalDetails`. */
  showSchedulingContext?: boolean
}) {
  const query = useQuery({
    queryKey: ['settings', props.tenantId, 'provider-resources'],
    queryFn: () =>
      props.providerResourceRepository!.getResources(props.tenantId),
    enabled: Boolean(props.providerResourceRepository),
  })
  return query.data?.authorityMode === 'FLIO_INFORMATIONAL' ? (
    <InformationalWorkingHoursSettings
      key={props.tenantId}
      tenantUid={props.tenantId}
      tenantLabel={props.tenantLabel}
    />
  ) : (
    <WorkingHoursEditor key={props.tenantId} {...props} />
  )
}
